import { forwardRef } from "react";
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from "@mui/material";

export type TToggleButtonGroupProps = MuiToggleButtonGroupProps;

const ToggleButtonGroup = forwardRef<HTMLDivElement, TToggleButtonGroupProps>(
  (props, ref) => <MuiToggleButtonGroup ref={ref} {...props} />,
);

export default ToggleButtonGroup;
